import { createAction, props } from '@ngrx/store';

import { InsurancePackage } from '@lib/core/models/insurance-package.interface';

export const setInsurancePackages = createAction(
  '[Insurance Packages] Set Packages',
  props<{
    insurancePackages: InsurancePackage[];
  }>()
);
